import { render } from "./StickyContainer.vue?vue&type=template&id=8529945e"
import script from "./StickyContainer.vue?vue&type=script&lang=js"
export * from "./StickyContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/StickyContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8529945e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8529945e', __exports__)) {
    api.reload('8529945e', __exports__)
  }
  
  module.hot.accept("./StickyContainer.vue?vue&type=template&id=8529945e", () => {
    api.rerender('8529945e', render)
  })

}


export default __exports__